export const CreditUsageConstants = {
    GET_CREDIT_USAGE_LIST_REQUEST: 'CREDIT_USAGE/GET_CREDIT_USAGE_LIST_REQUEST',
    GET_CREDIT_USAGE_LIST_SUCCESS: 'CREDIT_USAGE/GET_CREDIT_USAGE_LIST_SUCCESS',
    GET_CREDIT_USAGE_LIST_ERROR: 'CREDIT_USAGE/GET_CREDIT_USAGE_LIST_ERROR',
    GET_CREDIT_USAGE_CHART_REQUEST: 'CREDIT_USAGE/GET_CREDIT_USAGE_CHART_REQUEST',
    GET_CREDIT_USAGE_CHART_SUCCESS: 'CREDIT_USAGE/GET_CREDIT_USAGE_CHART_SUCCESS',
    GET_CREDIT_USAGE_CHART_ERROR: 'CREDIT_USAGE/GET_CREDIT_USAGE_CHART_ERROR',
    GET_CREDIT_DETAILS_REQUEST: 'CREDIT_DETAILS/GET_CREDIT_DETAILS_REQUEST',
    GET_CREDIT_DETAILS_SUCCESS: 'CREDIT_DETAILS/GET_CREDIT_DETAILS_PLAN_SUCCESS',
    GET_CREDIT_DETAILS_ERROR: 'CREDIT_DETAILS/GET_CREDIT_DETAILS_ERROR',
    GET_CREDIT_USAGE_SUMMARY_REQUEST: 'CREDIT_USAGE/GET_CREDIT_USAGE_SUMMARY_REQUEST',
    GET_CREDIT_USAGE_SUMMARY_SUCCESS: 'CREDIT_USAGE/GET_CREDIT_USAGE_SUMMARY_SUCCESS',
    GET_CREDIT_USAGE_SUMMARY_ERROR: 'CREDIT_USAGE/GET_CREDIT_USAGE_SUMMARY_ERROR',
  };